import { FormEvent, useState } from 'react';
import { api, INTERVAL_HU, Recurring } from '../api';
import { ErrorBox, Field, useAsync } from './ui';

const nextMonthStart = () => { const d = new Date(); return new Date(Date.UTC(d.getFullYear(), d.getMonth() + 1, 1)).toISOString().slice(0, 10); };

/**
 * Ismétlődő számla felvétele egy meglévő számlából (fromInvoiceId) vagy egy meglévő ütemezés szerkesztése (rec).
 * Az ütemező minden reggel kiállítja az esedékeseket; a teljesítés dátuma a „következő kiállítás” napja lesz.
 */
export function RecurringForm({ fromInvoiceId, rec, defaultTitle, onClose, onSaved }: {
  fromInvoiceId?: string; rec?: Recurring; defaultTitle?: string; onClose: () => void; onSaved: (r: Recurring) => void;
}) {
  const [v, setV] = useState({
    title: rec?.title ?? defaultTitle ?? '', interval_months: rec?.interval_months ?? 1, next_date: rec?.next_date ?? nextMonthStart(),
    end_date: rec?.end_date ?? '', active: rec?.active ?? true,
  });
  const a = useAsync();
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const body = { ...(rec ? { id: rec.id } : { from_invoice_id: fromInvoiceId }), title: v.title.trim(), interval_months: Number(v.interval_months),
      next_date: v.next_date, end_date: v.end_date || null, active: v.active };
    const r = await a.run(() => api<Recurring>('/invoices/recurring', { method: 'POST', body }));
    if (r) onSaved(r);
  };
  const title = rec ? 'Ismétlődő számla' : 'Ismétlődővé tétel';
  return (
    <div className="modal-back" role="dialog" aria-modal="true" aria-label={title} onClick={onClose}>
      <div className="modal card" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {!rec && <p className="muted small">A számla vevője, tételei és fizetési módja alapján a CRM a megadott gyakorisággal magától kiállítja az új számlát a beállított számlázóban.</p>}
        <form className="form" onSubmit={submit}>
          <Field label="Megnevezés" hint="a listában így látszik"><input value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} required maxLength={200} /></Field>
          <div className="grid2">
            <Field label="Gyakoriság"><select value={v.interval_months} onChange={(e) => setV({ ...v, interval_months: Number(e.target.value) as Recurring['interval_months'] })}>
              {Object.entries(INTERVAL_HU).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
            <Field label="Következő kiállítás"><input type="date" value={v.next_date} onChange={(e) => setV({ ...v, next_date: e.target.value })} required /></Field>
            <Field label="Utolsó kiállítás legkésőbb" hint="üresen: visszavonásig"><input type="date" value={v.end_date} onChange={(e) => setV({ ...v, end_date: e.target.value })} /></Field>
          </div>
          {rec && <label className="check"><input type="checkbox" checked={v.active} onChange={(e) => setV({ ...v, active: e.target.checked })} /> Aktív</label>}
          {rec?.last_error && <div className="error">Legutóbbi hiba: {rec.last_error}</div>}
          <ErrorBox error={a.error} />
          <div className="actions">
            <button type="submit" disabled={a.busy}>Mentés</button>
            <button type="button" className="secondary" onClick={onClose}>Mégse</button>
          </div>
        </form>
      </div>
    </div>
  );
}
